import { rankingItems } from '@/mocks/home';

function TrendIcon({ trend }: { trend: string }) {
  if (trend === 'up') return <i className="ri-arrow-up-line text-accent-500 w-4 h-4 flex items-center justify-center"></i>;
  if (trend === 'down') return <i className="ri-arrow-down-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>;
  return <i className="ri-subtract-line text-foreground-400 w-4 h-4 flex items-center justify-center"></i>;
}

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-3">人气排行</h2>
          <p className="text-sm md:text-base text-foreground-600">当前最受读者欢迎的耽美漫画作品</p>
        </div>

        <div className="space-y-2 md:space-y-3">
          {rankingItems.map((item) => (
            <div key={item.rank} className="flex items-center gap-3 md:gap-4 bg-background-50 rounded-xl md:rounded-2xl p-4 md:p-5 border border-background-200/70 hover:scale-[1.01] transition-all duration-200 cursor-pointer">
              <div className={`w-8 h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center font-heading text-lg md:text-xl font-bold flex-shrink-0 ${
                item.rank === 1 ? 'bg-accent-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="font-heading text-sm md:text-base text-foreground-900 truncate">{item.title}</h3>
                  <span className="text-[10px] md:text-xs bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full whitespace-nowrap">{item.genre}</span>
                </div>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line w-3 h-3 flex items-center justify-center"></i>
                    {item.author}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-amber-400 w-3 h-3 flex items-center justify-center"></i>
                    {item.score}
                  </span>
                </div>
              </div>

              <div className="flex items-center gap-1 text-xs flex-shrink-0">
                <TrendIcon trend={item.trend} />
                <span className={item.trend === 'up' ? 'text-accent-500 font-medium' : item.trend === 'down' ? 'text-primary-500 font-medium' : 'text-foreground-400'}>{item.change}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}